import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function PaidRoute({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<"loading" | "allowed" | "blocked">("loading");
  useEffect(() => {
    fetch("api/access/status", { credentials: "include" })
      .then(async (response) => {
        if (!response.ok) throw new Error();
        const data = await response.json();
        setState(data.authenticated && data.paid ? "allowed" : "blocked");
      })
      .catch(() => setState("blocked"));
  }, []);
  if (state === "loading") return <div className="checkout-page"><main className="checkout-card"><p>Verificando seu acesso…</p></main></div>;
  if (state === "blocked") return <Navigate to="/acesso" replace />;
  return <>{children}</>;
}
